module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Medium.5648e504.woff";